/**
 * PSIFY IMMERSIVE — pagina de serviciu v2 (02.10.2026), după macheta mockups/serviciu-klearmind-v2 (src/page.js).
 * Compilat la public/js/immersive-service.min.js și încărcat DOAR de service-page-immersive.blade.php.
 * Fără GSAP, jQuery sau altă bibliotecă: linia pașilor, clipurile (primul ecran, cu treptele lui, și pașii),
 * înălțimea pozei de la „Situații frecvente”, orașele, întrebările.
 * Scena cu derulare din primul ecran (poza care creștea până la tot ecranul, 01.10.2026) e scoasă (owner, 04.10.2026);
 * la fel desenul de pe ecranul laptopului de la „Flexibilitate”: interfața de ședință e în fișierul pozei.
 * Galeria specialiștilor NU e aici: o face chapters.js (initDoctorsGallery), ca pe prima pagină.
 */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* linia pașilor: capetele ei stau pe primul și pe ultimul număr */
  var steps = document.getElementById('svc2-steps');
  var line = steps && steps.querySelector('.svc2-steps-line');
  var rows = steps ? Array.prototype.slice.call(steps.querySelectorAll('.svc2-step')) : [];
  var geo = null;
  var activeCount = -1;

  function measure() {
    if (!steps || !rows.length) return;
    var top = steps.getBoundingClientRect().top + window.scrollY;
    var centers = rows.map(function (row) {
      var r = row.querySelector('.svc2-step-node').getBoundingClientRect();
      return r.top + window.scrollY + r.height / 2 - top;
    });
    var first = centers[0];
    var last = centers[centers.length - 1];
    line.style.top = first + 'px';
    line.style.bottom = 'auto';
    line.style.height = (last - first) + 'px';

    // în dreptul fiecărui număr linia e întreruptă, ca discul să stea liber pe fundal
    var r = rows[0].querySelector('.svc2-step-node').getBoundingClientRect().width / 2;
    var stops = ['transparent 0', 'transparent ' + r + 'px', '#000 ' + r + 'px'];
    centers.slice(1, -1).forEach(function (c) {
      var y = c - first;
      stops.push('#000 ' + (y - r) + 'px', 'transparent ' + (y - r) + 'px', 'transparent ' + (y + r) + 'px', '#000 ' + (y + r) + 'px');
    });
    stops.push('#000 ' + (last - first - r) + 'px', 'transparent ' + (last - first - r) + 'px');
    var mask = 'linear-gradient(to bottom, ' + stops.join(', ') + ')';
    line.style.webkitMaskImage = mask;
    line.style.maskImage = mask;
    geo = { top: top + first, height: last - first, centers: centers.map(function (c) { return c - first; }) };
    activeCount = -1;
    draw();
  }

  function draw() {
    if (!geo) return;
    var p = reduced ? 1 : (window.scrollY + window.innerHeight * 0.5 - geo.top) / geo.height;
    p = Math.max(0, Math.min(1, p));
    line.style.setProperty('--p', p.toFixed(4));
    var reached = p * geo.height;
    var count = 0;
    geo.centers.forEach(function (c) { if (reached >= c - 1) count++; });
    if (count !== activeCount) {
      activeCount = count;
      rows.forEach(function (row, i) { row.classList.toggle('is-active', i < count); });
    }
  }

  if (steps && rows.length) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; draw(); });
    }, { passive: true });
    window.addEventListener('load', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(steps);
    measure();
  }

  /* clipurile (primul ecran și pașii): se încarcă doar când te apropii, pornesc mute și stau când ies din ecran;
     cu „reducere mișcare” sau „economisire de date” nu se încarcă deloc, rămâne poza */
  var clips = Array.prototype.slice.call(document.querySelectorAll('.svc2-step-clip'));
  var conn = navigator.connection;
  if (clips.length && !reduced && !(conn && conn.saveData) && 'IntersectionObserver' in window) {
    var phoneClip = window.matchMedia('(max-width: 899px)');
    var tryPlay = function (v) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.classList.add('is-static'); });
    };
    /* treptele clipului din primul ecran (owner, 01.10.2026: „la zoom se vede șters”): data-desk-trepte / data-phone-trepte
       (din manifest, crescător); se ia prima treaptă cu lățimea ≥ 75 % din pixelii fizici ceruți (lățimea clipului pe
       ecran × devicePixelRatio), adică mărire ≤ 1,33×; pe 2g/3g, cea mai mică */
    var pickTier = function (v, kind) {
      var raw = v.dataset[kind + 'Trepte'];
      if (!raw) return null;
      var trepte;
      try { trepte = JSON.parse(raw); } catch (e) { return null; }
      if (!trepte || !trepte.length) return null;
      if (conn && /^[23]g$/.test(conn.effectiveType || '')) return trepte[0];
      var need = (v.getBoundingClientRect().width || 0) * (window.devicePixelRatio || 1) * 0.75;
      for (var i = 0; i < trepte.length; i++) if (trepte[i].w >= need) return trepte[i];
      return trepte[trepte.length - 1];
    };
    var near = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var v = e.target;
        near.unobserve(v);
        var k = phoneClip.matches ? 'phone' : 'desk';
        var tier = pickTier(v, k);
        ['webm', 'mp4'].forEach(function (f) {
          var s = document.createElement('source');
          s.src = tier ? tier[f] : v.dataset[k + f.charAt(0).toUpperCase() + f.slice(1)];
          s.type = 'video/' + f;
          v.appendChild(s);
        });
        v.preload = 'auto';
        v.load();
        if (v.dataset.visible === '1') tryPlay(v);
      });
    }, { rootMargin: '300px 0px' });
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v.dataset.visible = e.isIntersecting ? '1' : '0';
        if (e.isIntersecting) { if (v.querySelector('source')) tryPlay(v); } else v.pause();
      });
    }, { threshold: 0.25 });
    clips.forEach(function (v) {
      v.addEventListener('playing', function () { v.classList.add('is-on'); });
      near.observe(v);
      seen.observe(v);
    });
    // la întoarcerea în tab, filmele se reașază înainte să pornească: pe iPhone (owner, 02.10.2026) Safari le desena
    // mărite după ce reveneai din alt tab (stratul nativ al videoului se reface fără object-fit până la o nouă așezare;
    // refresh-ul o făcea); aici o forțăm: strat refăcut (display) și object-fit pus din nou
    var reaseaza = function (v) {
      v.style.display = 'none';
      void v.offsetHeight;
      v.style.display = '';
      v.style.objectFit = 'contain';
      void v.offsetHeight;
      v.style.objectFit = '';
    };
    var revenire = function () {
      clips.forEach(function (v) {
        if (document.hidden) { v.pause(); return; }
        reaseaza(v);
        if (v.dataset.visible === '1' && v.querySelector('source')) tryPlay(v);
      });
    };
    document.addEventListener('visibilitychange', revenire);
    window.addEventListener('pageshow', function (e) { if (e.persisted) revenire(); });
  }

  /* „Situații frecvente” (01.10.2026): poza are exact înălțimea casetei ei (de la primul rând până sub baza panoului);
     lățimea ei vine din înălțime, deci coloana de text se strânge puțin și rândurile se reașază: se măsoară de câteva ori,
     până se liniștește */
  var fitBody = document.querySelector('.svc2-fit-body');
  var fitMedia = document.querySelector('.svc2-fit-media');
  if (fitBody && fitMedia) {
    var fitLast = -1, fitRuns = 0;
    var fitSize = function () {
      if (getComputedStyle(fitMedia).display === 'none') return;
      var h = fitBody.getBoundingClientRect().height - parseFloat(getComputedStyle(fitMedia).marginBottom);
      if (Math.abs(h - fitLast) < 1 || fitRuns > 8) return;
      fitLast = h; fitRuns++;
      fitMedia.style.setProperty('--fit-h', h + 'px');
    };
    fitSize();
    window.addEventListener('load', fitSize);
    window.addEventListener('resize', function () { fitLast = -1; fitRuns = 0; fitSize(); });
    if ('ResizeObserver' in window) new ResizeObserver(fitSize).observe(fitBody);
  }

  /* „Psiholog la cabinet” (01.10.2026): textul cu săgeată arată sau ascunde orașele de sub butoane */
  var oraseBtn = document.querySelector('.svc2-orase-toggle');
  var orase = document.getElementById('svc2-orase');
  if (oraseBtn && orase) {
    oraseBtn.addEventListener('click', function () {
      var open = oraseBtn.getAttribute('aria-expanded') === 'true';
      oraseBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      orase.hidden = open;
    });
  }

  /* întrebările: ca pe site, clasa is-open desface răspunsul */
  Array.prototype.slice.call(document.querySelectorAll('.svc2-faq-list .psi-faq-toggle')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.psi-faq-item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();
